<template lang="html">
  <div
    v-if="visible"
    :class="[ `dropdown--anchor-${anchor}`, { 'dropdown--minwidth': minWidth } ]"
    class="dropdown"
  >
    <slot />
  </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
  props: {
    anchor: VueTypes.oneOf(['left', 'right', 'center']).def('center'),
    minWidth: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/zindex';

  .dropdown {
    box-sizing: border-box;
    position: absolute;
    top: 100%;
    background-color: gray(4);
    padding: scale(6);
    z-index: zindex(4);
    &--minwidth {
      min-width: scale(84);
    }
  }

  .dropdown--anchor-left {
    left: 0;
  }

  .dropdown--anchor-right {
    right: 0;
  }

  .dropdown--anchor-center {
    left: 50%;
    transform: translateX(-50%);
  }
</style>
